__webpack_require__.p = "/DraftMenu/";